var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcPeople = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 20 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 904,
    height: 170,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-4.1%",
    width: "102.4%",
    height: "112.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.125,11 C16.39,11 17.4075,9.97333333 17.4075,8.70833333 C17.4075,7.44333333 16.39,6.41666667 15.125,6.41666667 C13.86,6.41666667 12.8333333,7.44333333 12.8333333,8.70833333 C12.8333333,9.97333333 13.86,11 15.125,11 L15.125,11 Z M8.25,10.0833333 C9.77166667,10.0833333 10.9908333,8.855 10.9908333,7.33333333 C10.9908333,5.81166667 9.77166667,4.58333333 8.25,4.58333333 C6.72833333,4.58333333 5.5,5.81166667 5.5,7.33333333 C5.5,8.855 6.72833333,10.0833333 8.25,10.0833333 L8.25,10.0833333 Z M15.125,12.8333333 C13.4475,12.8333333 10.0833333,13.6766667 10.0833333,15.3541667 L10.0833333,17.4166667 L20.1666667,17.4166667 L20.1666667,15.3541667 C20.1666667,13.6766667 16.8025,12.8333333 15.125,12.8333333 L15.125,12.8333333 Z M8.25,11.9166667 C6.11416667,11.9166667 1.83333333,12.9891667 1.83333333,15.125 L1.83333333,17.4166667 L8.25,17.4166667 L8.25,15.3541667 C8.25,14.575 8.5525,13.2091667 10.4225,12.1733333 C9.625,12.0083333 8.855,11.9166667 8.25,11.9166667 L8.25,11.9166667 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.-Enrich-company",
    transform: "translate(-299.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1206
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 143.5,
    width: 1441,
    height: 1063
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(268.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Black",
    fill: "#BEC4CA",
    xlinkHref: "#path-5"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPeople, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-people.f8d6ebe2.svg";
export { ForwardRef as ReactComponent };